import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { PlatformTaskInterfaceStateService } from '../services/platform-task-interface-state.service';

export const CanAccessTask: CanActivateFn = () => {
  inject(PlatformTaskInterfaceStateService).resetContext();
  return true;
};
